import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// Hooks
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectIntegrationById } from 'store/integrations/integrationsSelectors';
// Components
import { Toggle } from 'components/Controls';

type Props = {
  integrationId: string;
  index: number;
}

const IntegrationItem:FC<Props> = ({ integrationId, index }) => {
  const { control } = useFormContext();

  const integration = useAppSelector((state) => selectIntegrationById(state, { integrationId }));

  if (!integration) return null;
  return (
    <div className="flex items-center">
      <span className="block text-white text-base font-semibold mr-3">{integration.name}</span>
      <Controller
        control={control} name={`integrations.${index}.value`}
        render={({ field: { onChange, value } }) => (
          <Toggle
            id={`integration-item-${index}`}
            checked={value}
            onChange={onChange}
          />
        )}
      />
      </div>
  );
}

export default IntegrationItem;
